import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import { styled } from '@mui/system';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import Spinner, { DotLoader } from 'react-spinner-overlay';
import TablePagination, {
  tablePaginationClasses as classes,

} from '@mui/base/TablePagination';



const EditFeed = (props) => {
  const { handleSubmit } = useForm();
  
  const modal3 = props.modal3;
  const setModal3 = props.setModal3;
  const modal1 = props.modal1;
  const setModal1 = props.setModal1;
  const name = props.name;
  const setName = props.setName;
  const id = props.currentID;
  const feedType = props.feedType;
  const url = props.url;
  const autoSync = props.autoSync;
  const repeats = props.repeats;
  const durationFilterMin = props.durationFilterMin;
  const durationFilterMax = props.durationFilterMax;
  const sizeFilter = props.sizeFilter;
  const setUrl = props.setUrl;
  const setAsync = props.setAsync;
  const setRepeats = props.setRepeats;
  const setDurationFilterMin = props.setDurationFilterMin;
  const setDurationFilterMax = props.setDurationFilterMax;
  const setSizeFilter = props.setSizeFilter;
  const Root = props.Root;
  const CustomTablePagination = props.CustomTablePagination;
  const rows = props.rows;
  const setRows = props.setRows;
  const page = props.page;
  const rowsPerPage = props.rowsPerPage;
  const emptyRows = props.emptyRows;
  const handleChangePage = props.handleChangePage;
  const handleChangeRowsPerPage = props.handleChangeRowsPerPage;
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const getData = () => {
    console.log("getting the video's duration size info")
    let data = axios.post('/api/feeds/info', 
    {rssLink:url},
    {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setRows(response.data)
      })
      .catch(error => {
        // Handle error
        console.error(error);
      })

  }


  const getFilterData = () => {
    console.log("getting the video's duration size info")
    let data = axios.post('/api/feeds/info', 
    {rssLink:url},
    {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setRows(response.data)
      })
      .catch(error => {
        // Handle error
        console.error(error);
      })
      .finally(() => {
        setLoading(false); 
      });

  }


  const getFeedData = async () => {
    console.log("getting the videos")
    let data = await axios.get('/api/feeds/all', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setRows(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }

  const handleUpdate = (e) => {
    setIsProcessing(true);
    e.preventDefault();
    const postObj = {
      title: name,
      type: feedType,
      rssLink: url,
      autoSync: autoSync,
      repeats: repeats,
      filterDurationMin: durationFilterMin,
      filterDurationMax: durationFilterMax,
      filterSize: sizeFilter
    };
    console.log(postObj)
    let data = axios
      .put(`/api/feeds/syncUpdate/${id}`, postObj, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("userToken"),
        },
      })
      .then((response) => {
        getFeedData();
        showSuccessToast(
          response.data && response.data.Message
            ? response.data.Message
            : "Success"
        );

        setModal1(!modal1);
      })
      .catch((err) => {
        console.log(err);

        showErrorToast("Error!");
      }).finally(() => {
        setIsProcessing(false);
        props.getData()

      });

  };

  const clearModalData = () => {
    console.log("clearing data")
    setAsync('Yes')
    setDurationFilterMin(0)
    setDurationFilterMax(0)
    setRepeats("Every 5 minutes")
    setSizeFilter(0)
    // setUrl('')
    setName('')
  }

  const createFilters = () => {
    setLoading(true);
    getFilterData();
    setModal3(true);
  };

  const handleFiltersSubmit = (e) => {
    e.preventDefault();
    // console.log("Duration:", durationFilter);
    console.log("Size:", sizeFilter);
    setModal3(false);
  };

  const handleAsyncChange = (e) => {
    setAsync(e.target.value);
    if (e.target.value === "No") {
      setRepeats("");
    }
  };

  return (
    <div>
      <Modal
        size="lg"
        backdropClassName=""
        isOpen={modal3}
        toggle={() => setModal3(!modal3)}
      >
        <ModalHeader toggle={() => setModal3(!modal3)}>Edit Filter</ModalHeader>
        <ModalBody>
          <form onSubmit={handleFiltersSubmit}>
            <div>
              <div className="card card-plain">
                <div className="card-body">
                <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">
                      Minimum Duration:{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control w-50"
                      placeholder="Duration in Min"
                      value={durationFilterMin}
                      onChange={(e) => setDurationFilterMin(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">
                      Maximum Duration:{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control w-50"
                      placeholder="Duration in Min"
                      value={durationFilterMax}
                      onChange={(e) => setDurationFilterMax(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">Size: </label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Size in MB"
                        value={sizeFilter}
                        onChange={(e) => setSizeFilter(e.target.value)}
                        required
                        />
                  </div>
                  <Root sx={{ width: 1500, maxWidth: '100%' }}>
                {loading ? (
                  <div class="d-flex justify-content-center m-3">
                <DotLoader
                    visible={loading}
                    textContent={'Loading...'}
                    animation="grow"
                    overlayColor="rgba(0, 0, 0, 0.5)"
                    color="#5BC0F8"
                    
                   />
                   </div>
                ) : (         
                <table aria-label="custom pagination table">
                  <thead>
                    <tr>
                      <th style={{ width: '5%' }} className="text-center">Sr No.</th>
                      <th style={{ width: '25%' }} className="text-center">Name</th>
                      <th style={{ width: '15%' }} className="text-center">Duration</th>
                      <th style={{ width: '15%' }} className="text-center">Size</th>


                    </tr>
                  </thead>
                  <tbody>
                    {
                      (rowsPerPage > 0
                      ? rows
                      .filter((row) => {
                        const durationInMinutesMin =
                        row.duration / 60; // Convert seconds to minutes
                      const durationInMinutesMax =
                        row.duration / 60; // Convert seconds to minutes
                            const sizeInMB = row.size / (1024*1024); // Convert KB to MB

                            return (
                              (durationFilterMin === "" ||
                                durationInMinutesMin >=
                                  durationFilterMin) &&
                              (sizeFilter === "" ||
                                sizeInMB <= sizeFilter) &&
                              (durationFilterMax === "" ||
                                durationInMinutesMax <= durationFilterMax)
                            );
                        })
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : rows
                    )
                    .map((row, index) => (
                      console.log(row._id),
                      <tr key={row._id}>
                        <td>{index+1}</td>
                        <td style={{ width: '20%' }} >{row.name ? row.name : "No Title"}</td>
                        <td style={{ width: '20%' }} >{row.duration ? Math.floor(row.duration/60) + " mins " + row.duration%60 + " sec": "No Duration Found"}</td>
                        <td style={{ width: '20%' }} >{row.size ? Math.round(row.size/(1024*1024)) + " MB": "Size undefined"}</td>

                      </tr>
                    ))}
                    {emptyRows > 0 && (
                      <tr style={{ height: 34 * emptyRows }}>
                        <td colSpan={3} />
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <CustomTablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={rows.filter((row) => {
                          const durationInMinutesMin =
                          row.duration / 60; // Convert seconds to minutes
                        const durationInMinutesMax =
                          row.duration / 60; // Convert seconds to minutes
                            const sizeInMB = row.size / (1024*1024); // Convert KB to MB

                            return (
                              (durationFilterMin === "" ||
                                durationInMinutesMin >=
                                  durationFilterMin) &&
                              (sizeFilter === "" ||
                                sizeInMB <= sizeFilter) &&
                              (durationFilterMax === "" ||
                                durationInMinutesMax <= durationFilterMax)
                            );
                        }).length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        slotProps={{
                          select: {
                            'aria-label': 'rows per page',
                          },
                          actions: {
                            showFirstButton: true,
                            showLastButton: true,
                          },
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </tr>
                  </tfoot>
                </table>
                
              )}
              </Root>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn bg-gradient-info my-5 mb-2"
                    >
                      Save Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        size="lg"
        backdropClassName=""
        isOpen={modal1}
        toggle={() => setModal1(!modal1)}
        onClosed={() => clearModalData()}
      >
        <ModalHeader toggle={() => setModal1(!modal1)}>
          Edit Feed
        </ModalHeader>
        <ModalBody>
          <form>
            <div>
              <div className="card card-plain">
                <div className="card-body">
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Name: </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      value={name}
                      // onChange={(e) => setName(e.target.value)}
                      disabled
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed Purpose: </label>
                    <input
                      type="text"
                      placeholder="URL"
                      className="form-control"
                      value={"Video Upload"}
                      disabled
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed URL: </label>
                    <input
                      type="url"
                      placeholder="URL"
                      className="form-control"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      disabled
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed Type: </label>
                    <input
                      type="text"
                      className="form-control"
                      value="MRSS"
                      disabled
                     />
                    
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Automatically Sync: </label>
                    <select
                      className="form-select p-2"
                      aria-label="Default select example"
                      value={autoSync}
                      onChange={handleAsyncChange}
                    >
                      <option value="Yes" selected>Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Repeats: </label>
                    <select
                      className="form-select p-2"
                      aria-label="Default select example"
                      value={repeats}
                      onChange={(e) => setRepeats(e.target.value)}
                      disabled={autoSync === "No"}
                      required={autoSync === "Yes"}
                    >
                      
                      <option selected hidden>Select an option</option>
                      <option>Every 3 Hours</option>
                      <option>Every 12 Hours</option>
                      <option>Every 24 Hours</option>
                      <option>Every 2 Days</option>
                      <option>Every 7 Days</option>
                      

                    </select>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn bg-gradient-info my-5 mb-2"
                      onClick={(id)=>handleUpdate(id)}
                      disabled={isProcessing || !name  || !url || (autoSync == 'Yes' && !repeats)}
                    >
                      {isProcessing ? (
                  <span>Processing</span>
                ) : (
                  'Edit Feed'
                )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          
          <button
            type="button"
            className="btn bg-gradient-info my-2"
            onClick={createFilters}
          >
            Edit Filters
          </button>
        </ModalBody>
      </Modal>
    </div>

  );
};

export default EditFeed;
